<template>
  <v-card>
    <v-toolbar
      color="transparent"
      flat
    >
      <v-toolbar-title>אירועים אחרונים</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn
        flat
        @click="$router.push(`/events/archive?countries=${countryId}`)"
        v-if="events.length"
      >
        כל האירועים ב{{ country.name }}
      </v-btn> -->
    </v-toolbar>
    <v-divider />
    <v-list>
      <v-list-tile v-if="!events.length">
        <v-list-tile-content>
          <v-list-tile-title>אין אירועים</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile
        v-for="event in events"
        :key="'e' + event._id"
        avatar
        @click="$router.push(`/events/${event._id}`)"
      >

        <v-list-tile-content>
          <v-list-tile-title>{{ event.title }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ format(event.startDate, 'DD/MM/YYYY') }}</v-list-tile-sub-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-chip class="white--text" :color="event.type ? event.type.color : 'grey'">{{ event.type ? event.type.title : 'לא ידוע' }}</v-chip>
        </v-list-tile-action>

      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import { axiosInstance } from "@/api";

export default {
  data() {
    return {
      events: []
    };
  },
  computed: {
    country() {
      return this.$store.state.entities.countries[this.countryId];
    }
  },

  methods: {
    format,
    fetchLatestEvents() {
      let params = {
        q: JSON.stringify({ partners: this.partnerId }),
        limit: 10,
        sort: "-startDate"
      };
      axiosInstance.get("/events", { params }).then(({ data }) => {
        this.events = data.results;
      });
    }
  },

  beforeMount() {},
  mounted() {
    this.fetchLatestEvents();
  },
  props: ["partnerId"],
  components: {},
  watch: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partners/partner/PartnerEvents.vue